import { CSSProperties } from "react"

export const boxStyle: CSSProperties = {
    borderRadius: 5, 
    overflow: 'auto', 
    backgroundColor: '#F7F9FA'
}